import React, { useState, useEffect } from "react";
import { useStyles } from "./style";
import Logo from "../../../images/logo.png";
import { Link } from "gatsby";
import "./style.css";
import MobileMenu from "../mobile";
import { Container } from "@material-ui/core";
import SearchInput from "../../searchInput";
import { Grid } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

export default function Navbar() {
  const classes = useStyles();

  const [navActive, setNavActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSearch, setIsSearch] = React.useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      // Remove the event listener when the component is unmount.
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 30) {
      setNavActive(true);
    } else {
      setNavActive(false);
    }
  };

  const handleCloseMobileMenu = () => {
    setIsMobile(false);
  };

  const handleOpenMobileMenu = () => {
    setIsSearch(false);
    setIsMobile(true);
  };

  const handleResize = (e) => {
    if (window.innerWidth > 991) {
      setIsMobile(false);
    }
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg fixed-top vgl__navbar-active ${
          navActive && classes.navbarActive
        }`}
      >
        <div className="d-lg-none" style={{ width: "100%" }}>
          {/* <!--  Show this only on mobile to medium screens  --> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <ul className="navbar-nav">
              <li className="nav-item"> */}
            <div className={classes.mobileAction}>
              <SearchIcon
                style={{ fontSize: 35, color: "rgba(0,0,0,.5)" }}
                onClick={() => setIsSearch(!isSearch)}
              />
            </div>
            {/* </li>
            </ul> */}

            <Link
              className="navbar-brand d-lg-none header-logo"
              to="/"
              style={{ marginRight: 0 }}
            >
              <img
                src={Logo}
                className={`${
                  navActive ? classes.navLogoActive : classes.headerLogo
                }`}
                alt=""
              />
            </Link>

            <button
              className="navbar-toggler custom-toggler"
              type="button"
              data-toggle="collapse"
              // data-target="#navbarToggle"
              aria-controls="navbarToggle"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={handleOpenMobileMenu}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </div>
        {isSearch && (
          <div
            style={{
              position: "absolute",
              background: "#fff",
              borderRadius: 11,
              top: 75,
              left: 10,
            }}
          >
            <SearchInput classes={classes} />
          </div>
        )}
        <Container>
          {/* <!--  Use flexbox utility classes to change how the child elements are justified  --> */}
          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarToggle"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <SearchInput classes={classes} />
              </li>
            </ul>

            {/* <!--   Show this only lg screens and up   --> */}
            <Link
              className="navbar-brand d-none d-lg-block header-logo"
              to="/"
              style={{ marginRight: 0 }}
            >
              <img
                src={Logo}
                className={`${
                  navActive ? classes.navLogoActive : classes.headerLogo
                }`}
                alt=""
              />
            </Link>

            <div>
              <ul className="navbar-nav navbar-menu">
                <li className="nav-item dropdown">
                  <Link
                    className={`nav-link vgl__dropdown-option ${classes.primaryMenuLink}`}
                    to="#"
                    data-toggle="dropdown"
                  >
                    Read
                    <div className="nav-bg">
                      <ul
                        className="dropdown-menu-columns-2 multi-column "
                        style={{
                          paddingTop: 90,
                          background: "#fffcf2",
                        }}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            style={{
                              borderTop: "1px solid #fbc6bb",
                              borderBottom: "3px solid #fbc6bb",
                              paddingLeft: 15,
                            }}
                          >
                            <ul className="multi-column-dropdown">
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/features"
                                >
                                  Features
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/face"
                                >
                                  Face
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/body"
                                >
                                  Body
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/hair"
                                >
                                  Hair
                                </Link>
                              </li>
                            </ul>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            style={{
                              borderTop: "1px solid #fbc6bb",
                              borderRight: "3px solid #fbc6bb",
                              borderBottom: "3px solid #fbc6bb",
                            }}
                          >
                            <ul className="multi-column-dropdown">
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/look"
                                >
                                  Look
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/sex-and-dating"
                                >
                                  Sex
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  className={`nav-link ${classes.secondaryMenuLink}`}
                                  to="/blog/real-life"
                                >
                                  Real Life
                                </Link>
                              </li>
                            </ul>
                          </Grid>
                        </Grid>
                      </ul>
                    </div>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${classes.primaryMenuLink}`}
                    to="/reviews"
                  >
                    Reviews
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${classes.primaryMenuLink}`}
                    to="/"
                  >
                    Shop
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </nav>
      <MobileMenu handelMenu={handleCloseMobileMenu} isMenuOpen={isMobile} />
    </>
  );
}
